import { CartState } from '../Reducers/Cart.reducer';
import { Order } from '../Types/Order';
import { OrderRow } from '../Types/OrderRow';
import Product from '../Types/Product';

const getMetaEventId = () => {
  return global['MetaEventId'];
};

const fbq = (
  key: string,
  ev: string,
  data: any = undefined,
  eventID: any = undefined
) =>
  typeof window['fbq'] === 'function'
    ? window['fbq'](key, ev, data, eventID)
    : undefined;

export const metaServiceAddToCartEvent = (orderRow: OrderRow) => {
  if (fbq && global.MetaPixelId) {
    fbq(
      'track',
      'AddToCart',
      {
        content_name: orderRow.name,
        content_category:
          orderRow.gtmEcommerceItem?.item_category ??
          orderRow.categoryName,
        contents: [
          {
            id: orderRow.articleNumber,
            quantity: 1,
          },
        ],
        content_ids: orderRow.articleNumber,
        content_type: 'product',
        value:
          orderRow.priceInfo?.campaignPrice?.price ??
          orderRow.priceInfo?.price?.price ??
          0,
        currency: orderRow.priceInfo?.currency?.id ?? '',
        eventref: getEventRef(),
      },
      { eventID: getMetaEventId() }
    );
  }
};

export const metaServiceAddToWishListEvent = (product: Product) => {
  if (fbq && global.MetaPixelId) {
    fbq(
      'track',
      'AddToWishlist',
      {
        content_name: product.name,
        content_category: product.category,
        content_ids: [product.id],
        content_type: 'product',
        value: product.price?.price?.price ?? 0,
        currency: product.price?.currency?.id ?? '',
        eventref: getEventRef(),
      },
      { eventID: getMetaEventId() }
    );
  }
};

export const metaServiceInitiateCheckoutEvent = (cart: CartState) => {
  if (fbq && cart && global.MetaPixelId) {
    const contents =
      cart.orderRows?.map((row) => {
        return { id: row.articleNumber, quantity: row.quantity };
      }) || [];
    fbq(
      'track',
      'InitiateCheckout',
      {
        contents: contents,
        content_ids: contents.map((row) => row.id),
        content_type: 'product',
        eventref: getEventRef(),
        currency: cart.currency,
        num_items:
          cart.orderRows?.reduce((acc, row) => acc + row.quantity, 0) ?? 0,
        value: cart.total || 0,
      },
      { eventID: getMetaEventId() }
    );
  }
};

export const metaServicePurchaseEvent = (order: Order) => {
  if (fbq && order && global.MetaPixelId) {
    const contents =
      order.orderRows?.map((row) => {
        return { id: row.articleNumber, quantity: row.gtmQuantity };
      }) || [];
    fbq(
      'track',
      'Purchase',
      {
        contents: contents,
        content_ids: contents.map((row) => row.id),
        content_type: 'product',
        eventref: getEventRef(),
        currency: order?.currency ?? '',
        num_items: order?.orderRows?.length,
        value: order?.grandTotalValue,
      },
      { eventID: getMetaEventId() }
    );
  }
};

export const metaServiceNewsLetterEvent = () => {
  if (fbq && global.MetaPixelId) {
    fbq('track', 'Lead', {
      eventref: getEventRef(),
    });
  }
};

const getEventRef = () =>
  new URLSearchParams(window.location.search).get('eventref') == 'fb_oea'
    ? 'fb_oea'
    : '';
